/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Confirm_TitleInputs */

const en_delete_account_confirm_title = /** @type {(inputs: Delete_Account_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete your account?`)
};

const es_delete_account_confirm_title = /** @type {(inputs: Delete_Account_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres eliminar tu cuenta?`)
};

const ar_delete_account_confirm_title = /** @type {(inputs: Delete_Account_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل أنت متأكد من أنك تريد حذف حسابك؟`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete your account?" |
*
* @param {Delete_Account_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_confirm_title = /** @type {((inputs?: Delete_Account_Confirm_TitleInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Confirm_TitleInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_confirm_title(inputs)
	if (locale === "es") return es_delete_account_confirm_title(inputs)
	return ar_delete_account_confirm_title(inputs)
});